import React from 'react'
import PropTypes from 'prop-types'
import PlaylistSelector from '../PlaylistSelector'
import { Modal } from 'react-bootstrap'

const PlaylistEntryModal = props => {
  const selectPlaylist = playlist => {
    props.onAdd(playlist)
  }

  return (
    <Modal show={props.show} onHide={props.onHide}>
      <PlaylistSelector
        planEntry={props.planEntry}
        playlists={props.playlists}
        playlistEntries={props.playlistEntries}
        onSelect={selectPlaylist}
        isMarked={playlist => {
          return props.playlistEntries
            .filter({
              playlist: playlist.uuid,
              planEntry: props.planEntry.id
            })
            .exists()
        }}
      />
    </Modal>
  )
}

PlaylistEntryModal.defaultProps = {
  onAdded: () => {}
}

PlaylistEntryModal.propTypes = {
  onAdd: PropTypes.func,
  onHide: PropTypes.func,
  show: PropTypes.bool,
  planEntry: PropTypes.object,
  playlists: PropTypes.array,
  playlistEntries: PropTypes.object
}

export default PlaylistEntryModal
